"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const types = __importStar(require("./types"));
const addSpot = (state, action) => {
    if (state.genres === undefined || state.spots === undefined) {
        return {
            genres: { active: null, others: new Set(action.payload.spot.genres) },
            spots: [Object.assign({}, action.payload.spot, { visible: true })],
        };
    }
    else {
        return {
            genres: { active: null, others: new Set([...action.payload.spot.genres, ...state.genres.others]) },
            spots: [Object.assign({}, action.payload.spot, { visible: true }), ...state.spots],
        };
    }
};
const extractActiveGenres = (spots) => {
    const nested = spots
        .filter((spot) => spot.visible)
        .map((spot) => spot.genres);
    return new Set(Array.prototype.concat.apply([], nested));
};
const filter = (state, action) => {
    if (state.genres === undefined || state.spots === undefined) {
        throw new Error();
    }
    const { visibleGenre } = action.payload;
    const spots = state.spots.map((spot) => {
        if (spot.genres.includes(visibleGenre)) {
            return Object.assign({}, spot, { visible: true });
        }
        else {
            return Object.assign({}, spot, { visible: false });
        }
    });
    const genres = extractActiveGenres(spots);
    genres.delete(visibleGenre);
    return {
        genres: {
            active: visibleGenre,
            others: genres,
        },
        spots,
    };
};
const reset = (state, action) => {
    if (state.genres === undefined || state.spots === undefined) {
        throw new Error();
    }
    const spots = state.spots.map((spot) => (Object.assign({}, spot, { visible: true })));
    const others = extractActiveGenres(spots);
    return {
        genres: {
            active: null,
            others,
        },
        spots,
    };
};
const reducer = (state, action) => {
    if (state === undefined) {
        return {};
    }
    switch (action.type) {
        case types.ADD_SPOT:
            return addSpot(state, action);
        case types.FILTER:
            return filter(state, action);
        case types.RESET:
            return reset(state, action);
        default:
            return state;
    }
};
exports.default = reducer;
